import { createFileRoute } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import "modules/campaigns/lang"

export const Route = createFileRoute("/_base/_auth/campaigns/goals")({
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("campaigns.goalsManagement.title"),
    })
  },
})
